import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import _ from 'lodash';

import Link from '../../../components/Link/Link';
import CourseReviewForm from '../CourseReviewForm/CourseReviewForm';

import s from './CongratulationsModal.scss';

const messages = defineMessages({
  viewCertificateBtn: {
    id: 'CongratulationsModal.viewCertificateBtn',
    defaultMessage: 'View certificate',
  },
  backToIndexBtn: {
    id: 'CongratulationsModal.backToIndexBtn',
    defaultMessage: 'Back to index',
  },
  text: {
    id: 'CongratulationsModal.text',
    defaultMessage:
      'Congratulations, {courseName} completed, your certificate will appear on profile page in couple of minutes!',
  },
});

const CongratulationsModal = ({ onClose, course, hideCertificateBtn }) => {
  const [showCourseReview, setShowCourseReview] = useState(
    course.type === 'normal',
  );

  return (
    <div className={s.paper} data-test="congratulations-modal">
      <Typography className={s.text} variant="subtitle1">
        <FormattedMessage
          {...messages.text}
          values={{ courseName: course.name }}
        />
      </Typography>
      <div className={s.partyIcon} />
      {showCourseReview ? (
        <CourseReviewForm
          isCongratsModal
          handleClose={() => setShowCourseReview(false)}
        />
      ) : (
        <div>
          <Button
            variant="outlined"
            color="primary"
            data-test="back-to-index-btn"
            component={Link}
            to="/"
            className={s.backToIndexBtn}
          >
            <FormattedMessage {...messages.backToIndexBtn} />
          </Button>
          {!hideCertificateBtn && (
            <Button
              variant="outlined"
              color="secondary"
              id="view-certificate-btn"
              component={Link}
              to={`/cert/${_.get(course, 'certificate.code', '')}`}
              className={s.viewCertificateBtn}
            >
              <FormattedMessage {...messages.viewCertificateBtn} />
            </Button>
          )}
        </div>
      )}
      <div className={s.closeModalBtn}>
        <IconButton
          data-test-id="SB_C1RStvzbKP5EnegBFP"
          onClick={onClose}
          data-test="close-congratulations-btn"
        >
          <CloseIcon className={s.closeIcon} />
        </IconButton>
      </div>
    </div>
  );
};

CongratulationsModal.propTypes = {
  lang: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  course: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['normal', 'livestream', 'podcast']).isRequired,
    certificate: PropTypes.shape({
      code: PropTypes.string.isRequired,
    }),
  }).isRequired,
  hideCertificateBtn: PropTypes.bool,
};

CongratulationsModal.defaultProps = {
  hideCertificateBtn: false,
};

export default injectIntl(withStyles(s)(CongratulationsModal));
